<script>
import Banner from "@/components/atoms/Banner";
import Drawer from "@/components/atoms/Drawer";
export default {
  components: { Banner, Drawer },
  data(){
    return {
      activeVideo: 0,
      videos: [
        {
          title: "Moving around the app",
          id: "EQL21XQnYKE"
        },
        {
          title: "Rotating",
          id: "O06R7qh2cX4"
        },
        {
          title: "Selecting",
          id: "CXiZIrS87Eo"
        },
        {
          title: "Moving parts",
          id: "hjm1XT4evRU"
        },
        {
          title: "Selecting multiple parts",
          id: "vghajhDuPig"
        },
        {
          title: "Snapping",
          id: "fBou2GZ9lto"
        },
        {
          title: "Aligning",
          id: "02s0PgG-tno"
        },
        {
          title: "Extruding",
          id: "lG1XTUc0Gqs"
        },
        {
          title: "Copy & Delete",
          id: "Tvk01zzifwQ"
        },
        {
          title: "Part Palette",
          id: "5LrBk-kvDrg"
        },
        {
          title: "Part Catalog",
          id: "CRc-5VhenZo"
        },
      ]
    }
  }
}
</script>

<template>
  <Banner>
    <Drawer>
      <template v-slot:drawer> 
        <div class="video-button-container">
          <div class="video-button" v-for="(video, index) in videos" :key="video.id" @click="activeVideo = index" :class="{active: index == activeVideo}">
            {{index + 1}}. {{video.title}}
          </div>
        </div>
      </template>
      <template v-slot:page>
        <div>
          <div id="tutorial-page" :class="{vr: $store.get('vr')}">
            <div class="video-container" v-for="video in videos" :key="video.id" v-if="videos[activeVideo].id == video.id">
              <iframe sandbox="allow-scripts allow-same-origin" ref="iframeContent" id="youtube-236" frameborder="0" allowfullscreen="1" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" :src='"https://www.youtube-nocookie.com/embed/"+video.id+"?autoplay=1&amp;controls=0&amp;disablekb=1&amp;playsinline=1&amp;cc_load_policy=0&amp;cc_lang_pref=auto&amp;hd=1&amp;vq=hd1080&amp;widget_referrer=http%3A%2F%2Flocalhost%3A8080%2F%23%2Ftutorials&amp;noCookie=true&amp;rel=0&amp;showinfo=0&amp;iv_load_policy=3&amp;modestbranding=1&amp;enablejsapi=1&amp;origin=http%3A%2F%2Flocalhost%3A8080&amp;widgetid=1"' data-gtm-yt-inspected-4="true"></iframe>
            </div>
          </div>
        </div>
      </template>
    </Drawer>
  </Banner>
</template>

<style lang="scss">
@import "~@/styles/constants";
#tutorial-page{
  min-height: calc(100vh - 4rem);
  &.vr{
    min-height: calc(100vh);
    iframe{
      min-height: calc(100vh);
    }
  }
  iframe{
    width: 100%;
    min-height: calc(100vh - 4.5rem);
    border: 0px solid #000;
  }
}
.video-button-container{
  padding: 1rem;
  .video-button{
    font-size: 1.25rem;
    padding: 1rem;
    border-radius: 3px;
    &:hover, .hover{
      background-color: $black_4;
      cursor: pointer;
    }
    &.active{
      background-color: $p;
    }
  }
}
</style>
